import React, { ChangeEvent, Dispatch, FC, KeyboardEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fc } from 'i18n';
import { TepIntents } from 'constants/tep';
import Input from 'components/molecules/input';
import { FiltersGroups } from 'constants/filters';
import Button from 'core/react/general/form/Button';
import { ActionsSelect } from './actions-select/select';
import { actions } from 'core/redux/api/veta/tep/leases';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { contactInfo, search as searchIcon } from 'assets/icons';
import { leasesControlsSelector } from 'core/redux/selectors/tep';
import { FiltersControl } from 'components/molecules/filters-control';

import styles from './styles.module.css';

interface IRowProps {
  search: string | null;
  searchHandler: Dispatch<string>;
}

export const UpperRow: FC<IRowProps> = ({ search, searchHandler }) => {
  const dispatch = useDispatch();

  const { count } = useSelector(leasesControlsSelector);

  const [searchText, setSearchText] = useState<string>(search || '');

  const onType = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const onSearch = () => {
    searchHandler(searchText);
  };

  const resetSearch = () => {
    setSearchText('');
    searchHandler('');
  };

  const openOfficersModal = () => dispatch(actions.intent({ intent: TepIntents.ManageOfficers }));

  const handleKeyDown = ({ key }: KeyboardEvent<HTMLInputElement>) => key === 'Enter' && onSearch();

  return (
    <div className={styles.row}>
      <div className={styles.search}>
        <Input
          className={styles.searchInput}
          icon={searchIcon}
          placeholder={fc('search')}
          value={searchText}
          onChange={onType}
          onKeyDown={handleKeyDown}
          reset={resetSearch}
        />
        <Button className={styles.searchButton} onClick={onSearch}>
          {fc('search')}
        </Button>
        <FiltersControl filtersGroup={FiltersGroups.TepLeases} />
      </div>
      <div className={styles.flexRow}>
        {!!count && <ActionsSelect />}
        <div className={styles.contactInfo}>
          <SvgWrapper width={36} height={36} details={contactInfo} onClick={openOfficersModal} />
        </div>
      </div>
    </div>
  );
};
